//Constants
import * as ACTIONS from './actionTypes';

//Types
import { SearchResults,Connect } from './types';
import { ActionSearchByIDAPISuccess,ActionSearchByLabelAPISuccess,ActionConnectDealerToEngineAPISuccess } from './actions';
import { EngineDealer } from 'features/Dealers/state/types';
import enginedealerSagas from 'features/Dealers/state/sagas';

export interface ConnectByLabelState {
    searchedById: boolean
    searchedByName: boolean
    searchResults?: SearchResults
    connect?: Connect        
}

const defaultState: ConnectByLabelState = {
    searchedById: false,
    searchedByName: false,
    searchResults: undefined,
    connect: undefined
    
};

type ConnectByLabelAction = ActionSearchByIDAPISuccess | ActionSearchByLabelAPISuccess | ActionConnectDealerToEngineAPISuccess;

function connectByLabelReducer(state: ConnectByLabelState = defaultState, action: ConnectByLabelAction): ConnectByLabelState {
    switch (action.type) {
        case ACTIONS.SEARCHING_BY_ID_API_SUCCESS:
            {
                return {
                    ...state,
                    searchedById: true,
                    searchResults: (action as ActionSearchByIDAPISuccess).searchResults
                }
            }
        case ACTIONS.SEARCHING_BY_LABEL_API_SUCCESS:
            {
                return {
                    ...state,
                    searchedById: true,
                    searchedByName: true,
                    searchResults: (action as ActionSearchByLabelAPISuccess).searchResults
                }
            }
        case ACTIONS.DISCONNECT_DEALER_TO_ENGINE_API_SUCCESS:        
        case ACTIONS.CONNECT_DEALER_TO_ENGINE_API_SUCCESS:
            {
                return {
                    ...state,
                    connect: (action as ActionConnectDealerToEngineAPISuccess).connect

                }
            }
        case ACTIONS.CLEAN_STATE:
            {
                return {
                    ...state,
                    searchedById: false,
                    searchedByName: false,
                    searchResults: undefined,
                    connect: undefined
                }
            }
        case ACTIONS.CLEAN_SEARCHRESULTS:
            {
                return {
                    ...state,
                    searchedById: true,
                    searchedByName: false,
                    searchResults: undefined,
                    connect: undefined
                }
            }
    }
    return {
        ...state
    }
}

export default connectByLabelReducer;